import { Accident } from "../CRUDs/entities/Accident";

export default {
    dropzoneFiles: {},

    init() {
        this.sort_date('accidents__table-box-img');
        this.initNewDropZone();
        this.listeners();
    },

    listeners(){
        $('body').off('click', '.data-view.accidents .data-row .edit')
                .on('click', '.data-view.accidents .data-row .edit', ev=>{
            new Accident($(ev.currentTarget).data('accident_id')).openModal('edit');
            $('#mask-time').datetimepicker(
                {format: 'hh:mm a', locale: 'en'}
            );
        })
    },

    sort_date(className = '') {
        if (className == '') return false;
        $('.' + className).click(function (e){
            let sortElem = $(this);

            if (sortElem.data('sort-direction') == 'desc') {
                sortElem.data('sort-direction', 'asc')
            }else{
                sortElem.data('sort-direction', 'desc')
            }
            if('URLSearchParams' in window && sortElem){
                let searchParams = new URLSearchParams(window.location.search);
                searchParams.set('sort', sortElem.data('sort'));
                searchParams.set('sort_direction', sortElem.data('sort-direction'));
                window.location.search = searchParams.toString();
            }
        });
    },

    initNewDropZone(){
        if(window.location.pathname.startsWith('/vehicles-management')){
            this.id = '';
            this.urlRoot = '/vehicles-mangement/';
            this.accident =  new Accident('', '/vehicles-management/vehicleAccident', 'vehicle-accident');
        }
    }
}
